// extracted by mini-css-extract-plugin
export default {"container":"newsletterButton_container__UMBXN"};